import { Component, inject, signal, output, input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-sign-in-card',
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslatePipe,
    RouterLink,
  ],
  templateUrl: './sign-in-card.component.html',
  styleUrl: './sign-in-card.component.scss',
})
export class SignInCardComponent {
  readonly loading = input<boolean>(false);
  readonly errorMessage = input<string | null>(null);
  readonly signIn = output<{ email: string; password: string }>();
  readonly forgotPassword = input<Array<string>>();

  protected readonly hidePassword = signal(true);

  private readonly fb = inject(FormBuilder);
  protected readonly form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });


  protected async onSubmit() {
    if (this.form.invalid) return;
    const { email, password } = this.form.value;
    this.signIn.emit({ email: email!, password: password! });
  }
}
